import React, { Component } from 'react'
import "./UploadFolderHeader.css"
import { injectIntl } from 'react-intl'

class UploadFolderHeader extends Component {
    
    render() {
        const {
            currentStep,
            intl
        } = this.props;
        return (
            <React.Fragment>
                <div
                    className='upload-folder-header'
                >
                    <p>
                        {(() => {
                            switch (currentStep) {
                                case 0:
                                    return intl.formatMessage({ id: 'upload-folder-header-m1' });
                                case 1:
                                    return intl.formatMessage({ id: 'upload-folder-header-m2' });
                                case 2:
                                    return intl.formatMessage({ id: 'upload-folder-header-m3' });
                                case 3:
                                    return intl.formatMessage({ id: 'upload-folder-header-m4' });
                                default:
                                    return "";
                            }
                        })()}
                    </p>
                </div>
            </React.Fragment>
        );
    }
}
export default injectIntl((UploadFolderHeader));
